<template>
  <div>
    <NavBar v-bind:displayLogo="false" v-bind:displayUser="true"></NavBar>
    <Menu v-show="true"></Menu>
    <StandSelectionForm :form="url"></StandSelectionForm>
  </div>  
</template>
<script>
  import NavBar from '@component-basic/NavBar.vue'
  import Menu from '@component-postulant/Menu.vue'
  import { Form } from 'vue-formio'
  export default{
    components: {
      NavBar,
      Menu,
      StandSelectionForm: Form
    },
    data() {
      return {
        url:'http://formio.ccbweb.cloud:3001/postulant/standselection'
      };
    }
  }
</script>